var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Link } from "react-router-dom";
import { Button, Dimmer, Divider, Icon, Input, List, Loader, Menu, Message, Modal, Popup, Table } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { rnaCishAccessionsPopup } from "../kit/rna-cish/ProbeSetForm";
import { debounce } from "../kit/rna-cish/ProKitForm";
import { abbreviateRnaWithModal } from "../kit/rna-fish/KitDisplay";
import { getWithAuthn } from "../RequestHelpers";
import AddAccessionModal from "./AddAccessionModal";
import AddProbeSetFamilyModal from "./AddProbeSetFamilyModal";
import AddVariantModal from "./AddVariantModal";
import AddVariantNoteModal from "./AddVariantNoteModal";
import { displayLocalTimestamp } from "./AllOrdersPage";
import ChangeDcvScoreModal from "./ChangeDcvScoreModal";
import ChangeDefaultVariantModal from "./ChangeDefaultVariantModal";
import ChangeVariantProductCompatibilityModal from "./ChangeVariantProductCompatibilityModal";
import ChangeVariantValidationModal from "./ChangeVariantValidationModal";
import ChangeVariantVisibilityModal from "./ChangeVariantVisibilityModal";
import SetProbeSetSizeModal from "./SetProbeSetSizeModal";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UpdateCurrentBatchModal from "./UpdateCurrentBatchModal";
var RnaCatalogPage = /** @class */ (function (_super) {
    __extends(RnaCatalogPage, _super);
    function RnaCatalogPage(props) {
        return _super.call(this, props) || this;
    }
    RnaCatalogPage.prototype.render = function () {
        return React.createElement(RnaCatalogPageContent, null);
    };
    return RnaCatalogPage;
}(React.Component));
export default RnaCatalogPage;
var RnaCatalogPageContent = /** @class */ (function (_super) {
    __extends(RnaCatalogPageContent, _super);
    function RnaCatalogPageContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderAddOrganismModal = function (props) {
            return React.createElement(AddOrganismModal, __assign({}, props));
        };
        _this.onOrgFilterChange = function (_, data) {
            var filter = data.value;
            _this.setState({
                orgFilter: filter,
                currentPage: 0,
            }, _this.loadCurrentCatalogPage);
        };
        _this.onTargetFilterChange = function (_, data) {
            var filter = data.value;
            _this.setState({
                targetFilter: filter,
                currentPage: 0,
            }, _this.loadCurrentCatalogPage);
        };
        _this.loadCurrentCatalogPage = function () {
            var path = "/admin/catalog/rna/paged/full?pageNumber=" + encodeURIComponent(_this.state.currentPage);
            if (_this.state.orgFilter !== "") {
                path = path + ("&organismFilter=" + encodeURIComponent(_this.state.orgFilter));
            }
            if (_this.state.targetFilter !== "") {
                path = path + ("&probeSetFamilyFilter=" + encodeURIComponent(_this.state.targetFilter));
            }
            _this.setState({ loading: true }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            catalog: resp.catalog,
                            totalPages: resp.catalog.totalPages
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load catalog: " + rej);
                });
            });
        };
        _this.onPageChange = function (_, data) {
            var activePage;
            if (data.className === 'prev') {
                activePage = _this.state.currentPage - 1;
            }
            else {
                activePage = _this.state.currentPage + 1;
            }
            var path = "/admin/catalog/rna/paged/full?pageNumber=" + encodeURIComponent(activePage);
            if (_this.state.orgFilter !== "") {
                path = path + ("&organismFilter=" + encodeURIComponent(_this.state.orgFilter));
            }
            if (_this.state.targetFilter !== "") {
                path = path + ("&probeSetFamilyFilter=" + encodeURIComponent(_this.state.targetFilter));
            }
            _this.setState({ loading: true }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        if (data.className === 'prev') {
                            _this.setState({
                                loading: false,
                                catalog: resp.catalog,
                                currentPage: _this.state.currentPage - 1,
                                totalPages: resp.catalog.totalPages
                            });
                        }
                        else {
                            _this.setState({
                                loading: false,
                                catalog: resp.catalog,
                                currentPage: _this.state.currentPage + 1,
                                totalPages: resp.catalog.totalPages
                            });
                        }
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load catalog: " + rej);
                });
            });
        };
        _this.renderCatalog = function (catalog) {
            catalog.organisms.sort(function (o1, o2) {
                if (o1.probeSetFamilies.length >= o2.probeSetFamilies.length) {
                    return -1;
                }
                else {
                    return 1;
                }
            });
            var orgFilter = _this.state.orgFilter.toLowerCase().trimStart().trimEnd();
            var targetFilter = _this.state.targetFilter.toLowerCase().trimStart().trimEnd();
            var filteredOrganisms = catalog.organisms.filter(function (o) { return o.name.toLowerCase().startsWith(orgFilter); });
            if (filteredOrganisms.length === 0) {
                return 'No matching organisms';
            }
            return React.createElement("ul", null, filteredOrganisms.map(function (org) {
                var renderPsfModal = function (props) {
                    return React.createElement(AddProbeSetFamilyModal, __assign({ orgId: org.id }, props));
                };
                var filteredFamilies = org.probeSetFamilies
                    .filter(function (psf) { return psf.geneSymbol.toLowerCase().startsWith(targetFilter) ||
                    psf.synonyms.find(function (s) { return s.toLowerCase() === targetFilter.toLowerCase(); }) !== undefined; });
                if (filteredFamilies.length === 0 && targetFilter.length > 0) {
                    // if there is a filter and this org has no probe set families, hide it completely
                    return React.createElement(React.Fragment, null);
                }
                return React.createElement("li", { className: 'organism', key: org.id },
                    React.createElement("h2", null,
                        React.createElement("span", { title: "Id " + org.id }, org.name + " (" + org.scientificName + ")"),
                        " - ",
                        displayLocalTimestamp(org.createdAt)),
                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'plus', label: 'Add probe set family', labelPosition: 'left' }) },
                        React.createElement(Modal.Header, null, "Add a probe set family"),
                        React.createElement(Modal.Content, null,
                            React.createElement(SimpleFormWithErrorDisplay, { render: renderPsfModal, successMessage: 'Probe set family added' }))),
                    React.createElement("ul", null, filteredFamilies.map(function (psf) {
                        var renderVariantModal = function (props) {
                            return React.createElement(AddVariantModal, __assign({ orgId: org.id, psfId: psf.id, accessions: psf.accessions }, props));
                        };
                        var renderAccessionModal = function (props) {
                            return React.createElement(AddAccessionModal, __assign({ orgId: org.id, psfId: psf.id }, props));
                        };
                        return React.createElement("li", { className: 'probe-set-family', key: psf.id },
                            React.createElement("h3", null,
                                React.createElement("span", { title: "Id " + psf.id }, psf.geneSymbol),
                                rnaCishAccessionsPopup(psf.accessions
                                    .sort(function (a, b) {
                                    return a.transcriptAccession.localeCompare(b.transcriptAccession);
                                }), 'Accessions'),
                                synonymsPopup(psf.synonyms, 'Synonyms'),
                                displayLocalTimestamp(psf.createdAt)),
                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'plus', label: 'Add variant', labelPosition: 'left' }) },
                                React.createElement(Modal.Header, null, "Add a variant"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderVariantModal, successMessage: 'Variant added' }))),
                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'plus', label: 'Add accession', labelPosition: 'left' }) },
                                React.createElement(Modal.Header, null, "Add an accession number"),
                                React.createElement(Modal.Content, null,
                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderAccessionModal, successMessage: 'Accession added' }))),
                            psf.variants.length > 0 &&
                                React.createElement(Table, { celled: true, collapsing: true, striped: true },
                                    React.createElement(Table.Header, null,
                                        React.createElement(Table.Row, null,
                                            React.createElement(Table.HeaderCell, null, "Variant"),
                                            React.createElement(Table.HeaderCell, null, "Target Sequence"),
                                            React.createElement(Table.HeaderCell, null, "Design Number"),
                                            React.createElement(Table.HeaderCell, null, "Dcv Score"),
                                            React.createElement(Table.HeaderCell, null, "Probe Size"),
                                            React.createElement(Table.HeaderCell, null, "Validated"),
                                            React.createElement(Table.HeaderCell, null, "Visible to admin"),
                                            React.createElement(Table.HeaderCell, null, "Visible to Consumer"),
                                            React.createElement(Table.HeaderCell, null, "Compatible With Fish"),
                                            React.createElement(Table.HeaderCell, null, "Compatible With Cish"),
                                            React.createElement(Table.HeaderCell, null, "Default"),
                                            React.createElement(Table.HeaderCell, null, "Notes"),
                                            React.createElement(Table.HeaderCell, null, "Source order"),
                                            React.createElement(Table.HeaderCell, null, "Created at"))),
                                    React.createElement(Table.Body, null, psf.variants.map(function (variant) {
                                        var renderSetProbeSetSizeModal = function (props) {
                                            return React.createElement(SetProbeSetSizeModal, __assign({ orgId: org.id, psfId: psf.id, variantId: variant.id, currentProbeSetSize: variant.probeSetSize }, props));
                                        };
                                        var renderVariantNoteModal = function (props) {
                                            return React.createElement(AddVariantNoteModal, __assign({ orgId: org.id, psfId: psf.id, variantId: variant.id }, props));
                                        };
                                        var renderChangeDcvScore = function () {
                                            return function (props) {
                                                return React.createElement(ChangeDcvScoreModal, __assign({ orgId: org.id, psfId: psf.id, variantId: variant.id, dcvScores: catalog.dcvScores, dcvScore: variant.dcvScore }, props));
                                            };
                                        };
                                        var probeSetSizeNode = React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'exchange', label: variant.probeSetSize, labelPosition: 'left' }) },
                                            React.createElement(Modal.Header, null, "Change probe size"),
                                            React.createElement(Modal.Content, null,
                                                React.createElement(SimpleFormWithErrorDisplay, { render: renderSetProbeSetSizeModal, successMessage: 'Probe size set' })));
                                        var renderChangeVisibility = function (targetVisibility, admin) {
                                            return function (props) {
                                                return React.createElement(ChangeVariantVisibilityModal, __assign({ orgId: org.id, psfId: psf.id, variantId: variant.id, targetVisibility: targetVisibility, admin: admin }, props));
                                            };
                                        };
                                        var renderChangeProductCompatibility = function (compatibility, fish) {
                                            return function (props) {
                                                return React.createElement(ChangeVariantProductCompatibilityModal, __assign({ orgId: org.id, psfId: psf.id, variantId: variant.id, compatibility: compatibility, fish: fish }, props));
                                            };
                                        };
                                        var renderChangeValidation = function () {
                                            return function (props) {
                                                return React.createElement(ChangeVariantValidationModal, __assign({ orgId: org.id, psfId: psf.id, variant: variant, validationTypes: catalog.validationTypes, validationType: variant.validated }, props));
                                            };
                                        };
                                        var visibleAdminNode = React.createElement(React.Fragment, null,
                                            "Yes ",
                                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye slash', title: 'Make invisible to admin' }) },
                                                React.createElement(Modal.Header, null, "Make variant invisible to admin"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeVisibility(false, true), successMessage: 'Variant made invisible to admin' }))));
                                        if (!variant.visibleToAdmin) {
                                            visibleAdminNode = React.createElement(React.Fragment, null,
                                                "No ",
                                                React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye', title: 'Make visible to admin' }) },
                                                    React.createElement(Modal.Header, null, "Make variant visible to admin"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeVisibility(true, true), successMessage: 'Variant made visible to admin' }))));
                                        }
                                        var visibleConsumerNode = React.createElement(React.Fragment, null,
                                            "Yes ",
                                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye slash', title: 'Make invisible to consumer' }) },
                                                React.createElement(Modal.Header, null, "Make variant invisible to consumer"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeVisibility(false, false), successMessage: 'Variant made invisible to consumer' }))));
                                        if (!variant.visibleToConsumer) {
                                            visibleConsumerNode = React.createElement(React.Fragment, null,
                                                "No ",
                                                React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye', title: 'Make visible to consumer' }) },
                                                    React.createElement(Modal.Header, null, "Make variant visible to consumer"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeVisibility(true, false), successMessage: 'Variant made visible to consumer' }))));
                                        }
                                        var dcvScoreNode = React.createElement(React.Fragment, null,
                                            variant.dcvScore ? variant.dcvScore.label : 'N/A',
                                            " ",
                                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'exchange' }) },
                                                React.createElement(Modal.Header, null, "Change Dcv Score"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeDcvScore(), successMessage: 'Dcv Score Changed' }))));
                                        var compatibleFishNode = React.createElement(React.Fragment, null,
                                            "Yes ",
                                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye slash', title: 'Make incompatible with fish' }) },
                                                React.createElement(Modal.Header, null, "Make variant incompatible with fish"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeProductCompatibility(false, true), successMessage: 'Variant made incompatible with fish' }))));
                                        if (!variant.compatibleWithFish) {
                                            compatibleFishNode = React.createElement(React.Fragment, null,
                                                "No ",
                                                React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye', title: 'Make compatible with fish' }) },
                                                    React.createElement(Modal.Header, null, "Make variant compatible with fish"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeProductCompatibility(true, true), successMessage: 'Variant made compatible with fish' }))));
                                        }
                                        var compatibleCishNode = React.createElement(React.Fragment, null,
                                            "Yes ",
                                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye slash', title: 'Make incompatible with cish' }) },
                                                React.createElement(Modal.Header, null, "Make variant incompatible with cish"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeProductCompatibility(false, false), successMessage: 'Variant made incompatible with cish' }))));
                                        if (!variant.compatibleWithCish) {
                                            compatibleCishNode = React.createElement(React.Fragment, null,
                                                "No ",
                                                React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'eye', title: 'Make compatible with cish' }) },
                                                    React.createElement(Modal.Header, null, "Make variant compatible with cish"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeProductCompatibility(true, false), successMessage: 'Variant made compatible with cish' }))));
                                        }
                                        var validateNode = React.createElement(React.Fragment, null,
                                            variant.validated,
                                            " ",
                                            React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'exchange' }) },
                                                React.createElement(Modal.Header, null, "Change Variant Validation"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeValidation(), successMessage: 'Validation Status Changed' }))));
                                        var defaultNode = React.createElement(Icon, { name: 'star' });
                                        if (!variant.isDefault) {
                                            // find the default one
                                            var variantPredicate = function (v) { return v.isDefault && psf.variants.some(function (psfV) { return psfV.id === v.id; }); };
                                            var defaultVariant_1 = psf.variants.find(variantPredicate);
                                            // should find one default always
                                            if (defaultVariant_1 === undefined) {
                                                throw new Error("Could not find default variant");
                                            }
                                            var renderChangeDefaultConfirmation = function (props) {
                                                return React.createElement(ChangeDefaultVariantModal, __assign({ orgId: org.id, psfId: psf.id, currentDefaultVariant: defaultVariant_1, newDefaultVariant: variant }, props));
                                            };
                                            defaultNode = React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'star', label: 'Set', labelPosition: 'left', title: "Current default variant: " + defaultVariant_1.name }) },
                                                React.createElement(Modal.Header, null, "Change default"),
                                                React.createElement(Modal.Content, null,
                                                    React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeDefaultConfirmation, successMessage: 'Default changed' })));
                                        }
                                        return React.createElement(Table.Row, { key: variant.id },
                                            React.createElement(Table.Cell, { title: "Id: " + variant.id }, variant.name),
                                            React.createElement(Table.Cell, null, abbreviateRnaWithModal(variant.targetMrnaSeq, true)),
                                            React.createElement(Table.Cell, null, variant.designNumber),
                                            React.createElement(Table.Cell, null, dcvScoreNode),
                                            React.createElement(Table.Cell, null, probeSetSizeNode),
                                            React.createElement(Table.Cell, null, validateNode),
                                            React.createElement(Table.Cell, null, visibleAdminNode),
                                            React.createElement(Table.Cell, null, visibleConsumerNode),
                                            React.createElement(Table.Cell, null, compatibleFishNode),
                                            React.createElement(Table.Cell, null, compatibleCishNode),
                                            React.createElement(Table.Cell, null, defaultNode),
                                            React.createElement(Table.Cell, null,
                                                React.createElement(Modal, { closeIcon: true, onClose: _this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'plus' }) },
                                                    React.createElement(Modal.Header, null, "Add a note"),
                                                    React.createElement(Modal.Content, null,
                                                        React.createElement(SimpleFormWithErrorDisplay, { render: renderVariantNoteModal, successMessage: 'Note added' }))),
                                                variant.notes.length > 0 ? _this.variantNotesModal(variant.notes) : ''),
                                            React.createElement(Table.Cell, null, variant.sourceOrderId
                                                ? React.createElement(Link, { to: AppPaths.ADMIN_ORDER_BASE + "/" + encodeURIComponent(variant.sourceOrderId) }, variant.sourceOrderId)
                                                : React.createElement("em", null, "none")),
                                            React.createElement(Table.Cell, null, variant.createdAt));
                                    }))));
                    })));
            }));
        };
        _this.variantNotesModal = function (notes) {
            return React.createElement(Modal, { trigger: React.createElement(Button, { icon: 'sticky note', label: notes.length.toString(), labelPosition: 'left' }), closeIcon: true },
                React.createElement(Modal.Header, null, "Notes"),
                React.createElement(Modal.Content, { className: 'variant-notes' }, notes.map(function (n, index) {
                    return React.createElement(React.Fragment, { key: index },
                        index > 0 ? React.createElement(Divider, null) : '',
                        React.createElement("div", { className: 'note' },
                            React.createElement("h3", null,
                                React.createElement("span", { title: n.user.id }, n.user.name),
                                " - ",
                                displayLocalTimestamp(n.createdAt)),
                            n.note));
                })));
        };
        _this.state = {
            loading: false,
            error: false,
            orgFilter: '',
            targetFilter: '',
            currentPage: 0,
            totalPages: 0
        };
        return _this;
    }
    RnaCatalogPageContent.prototype.render = function () {
        var updateCurrentBatchModal = function (props) {
            return React.createElement(UpdateCurrentBatchModal, __assign({}, props));
        };
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Catalog could not be loaded."),
                this.state.catalog &&
                    React.createElement("div", { className: 'catalog' },
                        React.createElement(Menu, null,
                            React.createElement(Menu.Item, null,
                                React.createElement(Modal, { closeIcon: true, onClose: this.loadCurrentCatalogPage, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Add organism' }) },
                                    React.createElement(Modal.Header, null, "Add an organism"),
                                    React.createElement(Modal.Content, null,
                                        React.createElement(SimpleFormWithErrorDisplay, { render: this.renderAddOrganismModal, successMessage: 'Organism added' })))),
                            React.createElement(Menu.Item, null,
                                React.createElement(Input, { placeholder: 'Filter org', icon: 'search', onChange: debounce(this.onOrgFilterChange, 300) })),
                            React.createElement(Menu.Item, null,
                                React.createElement(Input, { placeholder: 'Filter target', icon: 'search', onChange: debounce(this.onTargetFilterChange, 300) })),
                            React.createElement(Menu.Item, null,
                                React.createElement(Button, { disabled: this.state.currentPage === 0, label: 'prev', className: 'prev', labelPosition: 'right', icon: 'arrow left', onClick: this.onPageChange })),
                            React.createElement(Menu.Item, null,
                                React.createElement(Button, { disabled: (this.state.currentPage + 1) === this.state.totalPages, label: 'next', className: 'next', labelPosition: 'left', icon: 'arrow right', onClick: this.onPageChange })),
                            React.createElement(Menu.Item, null, this.state.currentPage + 1),
                            React.createElement(Menu.Item, null, this.state.totalPages),
                            React.createElement(Menu.Item, null,
                                this.state.catalog.outdated &&
                                    React.createElement(Modal, { closeIcon: true, onClose: this.loadCurrentCatalogPage, trigger: React.createElement(Button, { label: 'Update current batch', labelPosition: 'left' }) },
                                        React.createElement(Modal.Header, null, "Update current batch"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(SimpleFormWithErrorDisplay, { render: updateCurrentBatchModal, successMessage: 'Current batch updated' }))),
                                !this.state.catalog.outdated &&
                                    React.createElement("p", null, "Current batch up to date"))),
                        this.renderCatalog(this.state.catalog))));
    };
    RnaCatalogPageContent.prototype.componentDidMount = function () {
        this.loadCurrentCatalogPage();
    };
    return RnaCatalogPageContent;
}(React.Component));
export var synonymsPopup = function (synonyms, label) {
    return React.createElement(Popup, { className: 'synonyms-popup', trigger: React.createElement(Button, { icon: 'search plus', label: label, size: 'mini' }), on: 'click' },
        React.createElement(Popup.Header, null, "Synonyms"),
        React.createElement(Popup.Content, null,
            React.createElement(List, { bulleted: true }, synonyms.map(function (synonym, index) {
                return React.createElement(List.Item, { key: index }, synonym);
            }))));
};
var AddOrganismModal = /** @class */ (function (_super) {
    __extends(AddOrganismModal, _super);
    function AddOrganismModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onNameChange = function (_, data) {
            var str = data.value;
            _this.setState({ name: str });
        };
        _this.onScientificNameChange = function (_, data) {
            var str = data.value;
            _this.setState({ scientificName: str });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms", {
                name: _this.state.name,
                scientificName: _this.state.scientificName,
                organismFilter: _this.state.name
            });
        };
        _this.state = {
            name: '',
            scientificName: '',
            currentPage: 0
        };
        return _this;
    }
    AddOrganismModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/name', labelContent: 'Organism name' },
                React.createElement(Input, { onChange: this.onNameChange, placeholder: 'Human', value: this.state.name })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/scientificName', labelContent: 'Organism Scientific Name' },
                React.createElement(Input, { onChange: this.onScientificNameChange, placeholder: 'Homo sapien sapien', value: this.state.scientificName })),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Add organism', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddOrganismModal;
}(React.PureComponent));
//# sourceMappingURL=RnaCatalogPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/RnaCatalogPage.js
// module id = 591
// module chunks = 0